import styles from './Section.module.css';

// Обёртка секции с заголовком и опциональным подзаголовком
// bg: 'white' | 'gray' | 'accent' — цвет фона
const Section = ({ id, title, subtitle, bg = 'white', children, className = '' }) => {
  const sectionClasses = [styles.section, styles[bg], className].filter(Boolean).join(' ');

  return (
    <section id={id} className={sectionClasses}>
      <div className="container">
        {(title || subtitle) && (
          <div className={styles.header}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;
